import React from "react";
import { Route, Switch } from "react-router";
import { RestrictedRoute } from "../utils/RestrictedRoute";
import DiagnosticFlowsTable from "../components/WorkshopPlanning/General/DiagnosticFlows/DiagnosticFlowsTable";
import DiagnosticFlowsCreation from "../components/WorkshopPlanning/General/DiagnosticFlows/DiagnosticFlowsCreation";
import { Permissions } from "../utils/Permissions";

export default function DiagnosticFlowsRouting(props) {
  const { currentIdentity, resources } = props;

  return (
    <>
      <RestrictedRoute
        path="/diagnosticflows"
        exact
        userPermissions={currentIdentity.permissions}
        routePermissions={[Permissions.WorkshopSettings]}
        resources={resources}
        render={() => {
          return (
            <DiagnosticFlowsTable
              resources={resources}
              hasTranslationLicence={currentIdentity.hasTranslationLicence}
            />
          );
        }}
      />
      <Switch>
        <Route
          exact
          path="/diagnosticflows/new"
          render={() => (
            <DiagnosticFlowsCreation
              resources={resources}
              accessibleMoboOutlets={currentIdentity.accessibleMoboOutlets}
              objectType={currentIdentity.objectType}
              hasTranslationLicence={currentIdentity.hasTranslationLicence}
            />
          )}
        />
        <Route
          path="/diagnosticflows/:flowId"
          render={(routeProps) => {
            const { flowId } = routeProps.match.params;
            return (
              <DiagnosticFlowsCreation
                resources={resources}
                flowId={flowId}
                accessibleMoboOutlets={currentIdentity.accessibleMoboOutlets}
                objectType={currentIdentity.objectType}
                hasTranslationLicence={currentIdentity.hasTranslationLicence}
              />
            );
          }}
        />
      </Switch>
    </>
  );
}
